// extracted by mini-css-extract-plugin
export default {"container":"StY8_z","footer":"fLuSnx"};